'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { TypeStyleHeadlineMicro } from '../TypeStyle';
import { InputLabelRequiredAsterisk } from './InputLabelRequiredAsterisk';
export const InputLabel = styled(({ children, required, ...rest }) => {
    return (_jsxs(TypeStyleHeadlineMicro, { textTransform: 'uppercase', ...rest, children: [children, required ? _jsx(InputLabelRequiredAsterisk, {}) : null] }));
}) `
  margin-bottom: ${o => o.theme.spacing(1)};
`;
//# sourceMappingURL=InputLabel.js.map